import { render } from "./OrderListPage.vue?vue&type=template&id=b32ebce6&ts=true"
import script from "./OrderListPage.vue?vue&type=script&lang=ts"
export * from "./OrderListPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__